import { z } from 'zod';
import { emailAsArray } from '@/features/permissions/lib/collaboratorForm.lib';

const isValidEmail = (email: unknown) =>
  z.string().email().safeParse(email).success;

export const AddOrganizationMembersSchema = z.object({
  email: z
    .string({ message: 'Email address is required' })
    .trim()
    .min(1, { message: 'Email address is required' })
    .superRefine((value, ctx) => {
      const invalidEmails = emailAsArray(value).filter(
        (email) => !isValidEmail(email)
      );

      if (invalidEmails.length > 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message:
            invalidEmails.length === 1
              ? `${invalidEmails[0]} is not a valid email address`
              : `${invalidEmails.join(', ')} are not valid email addresses`,
          params: { actualValue: value },
        });
      }
    }),
});

export type AddOrganizationMembersDto = z.infer<
  typeof AddOrganizationMembersSchema
>;
